module.exports = __webpack_public_path__ + "img/undraw_not_found.896aac41.svg";